// Entry to superuser page

import Sidenav from './SuperAdminSidebar';

export default function SuperUser() {
    return (
            <Sidenav />
    );
}